/**
 * 请求+等待
 * 为了解决请求php后，php需要去操作python，然后等结果的情况
 * requestParam 和axios一样
 * interval 放state里面的 bianmaInterval: { timer: any; time: number };在页面关闭时需要清空
 * 第一步的data，会放到第二个的请求里面
 * php根据 axiosStep=1表示第一步，axiosStep=2表示第二步，第二步返回msg=wait表示继续等待，其他表示结束
 *  */
import baseService from '@/utils/http/axios'


const baseServicePlus = function (requestParam, interval) {
    return new Promise((resolve, reject) => {
        if (interval.timer === undefined) {
            reject('请先初始化interval')
        }
        interval.time = interval.time ? interval.time : 5000
        interval.time = interval.time < 1000 ? 1000 : interval.time
        // 补上步骤参数
        requestParam.data.axiosStep = 1
        baseService(requestParam).then((res: any) => {
            // 第一步成功，进行第二步循环等待
            let newData = { ...res.data, axiosStep: 2 }
            requestParam.data = newData
            interval.timer = setInterval(() => {
                baseService(requestParam).then((res: any) => {
                    if (res.msg == 'wait') {
                        //继续等待
                    } else {
                        clearInterval(interval.timer)
                        // 这个只会第一次成功，后面的会会被忽略
                        resolve(res)
                    }
                }).catch((res) => {
                    clearInterval(interval.timer)
                    reject(res)
                })
            }, interval.time)
        }).catch((res) => {
            reject(res)
        })
    })
}
export default baseServicePlus
